import { useCallback } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import { NativeModalId } from '~/context/home/ModalContext/constants';
import sendMessageToOpenNativeModal from '../dispatchers/sendMessageToOpenNativeModal';

function useNativeOpenSoftPullOnClick() {
  const isNative = useIsNative();

  return useCallback(
    (event: React.MouseEvent) => {
      if (!isNative) return;

      event.preventDefault();

      sendMessageToOpenNativeModal(NativeModalId.SoftPull);
    },
    [isNative]
  );
}

export default useNativeOpenSoftPullOnClick;
